import { ReviewerConfigInput, ReviewerTypeEnum } from '@/types/schema';

export const DEFAULT_REVIEWER_CONFIG: ReviewerConfigInput = {
  type: ReviewerTypeEnum.Specific,
};
